module.exports = __webpack_public_path__ + "static/media/delivery_2.ff7f517b.png";